module.exports = __webpack_public_path__ + "static/media/discord2.4fd8604b.png";